var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { tracked } from '@glimmer/tracking';
import { computed, set } from '@ember/object';
import Service, { inject as service } from '@ember/service';
import { Money, Currency } from '@square/dashboard-protos/models/squareup/connect/v2/common/money';
import { TransferType } from '@square/dashboard-protos/models/squareup/sfs/models/transfer';
import { ExternalBankAccount } from '@square/dashboard-protos/models/squareup/sfs/external/models/external_bank_account';
import { v4 as uuid } from 'uuid';
import { Account } from '@square/dashboard-protos/models/squareup/banking/account_model';
import { AccountType } from '@square/dashboard-protos/models/squareup/banking/common';
import { Validation } from '@banking/ui/utils/validation';
import formatMoney from '@banking/ui/utils/format-money';
let CurrentTransfer = (_dec = computed('_remainingWeeklyDeposits', 'requestedMoney.amount', 'sfsCustomerApi.remainingWeeklyDeposits.amount'), _dec2 = computed('_remainingWeeklyWithdrawals', 'requestedMoney.amount', 'sfsCustomerApi.remainingWeeklyWithdrawals.amount'), _dec3 = computed('primaryAccount.type', 'secondaryAccount.type'), _dec4 = computed('customerLimits', 'requestedMoney.amount', 'sfsCustomerApi.remainingWeeklyWithdrawals.amount'), _dec5 = computed('customerLimits', 'requestedMoney.amount', 'sfsCustomerApi.remainingWeeklyDeposits.amount'), _class = class CurrentTransfer extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "sfsCustomerApi", _descriptor, this);
    _initializerDefineProperty(this, "sfsTransferApi", _descriptor2, this);
    _initializerDefineProperty(this, "bankingTransferApi", _descriptor3, this);
    _initializerDefineProperty(this, "sfsExternalBankAccountApi", _descriptor4, this);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor5, this);
    _initializerDefineProperty(this, "intl", _descriptor6, this);
    _initializerDefineProperty(this, "formatter", _descriptor7, this);
    _initializerDefineProperty(this, "features", _descriptor8, this);
    _initializerDefineProperty(this, "secondaryAccount", _descriptor9, this);
    _initializerDefineProperty(this, "secondaryOptions", _descriptor10, this);
    _initializerDefineProperty(this, "requestedMoney", _descriptor11, this);
    _initializerDefineProperty(this, "primaryAccount", _descriptor12, this);
    _initializerDefineProperty(this, "transfer", _descriptor13, this);
    _initializerDefineProperty(this, "isDeposit", _descriptor14, this);
    _initializerDefineProperty(this, "idempotencyKey", _descriptor15, this);
    _initializerDefineProperty(this, "customerLimits", _descriptor16, this);
    _defineProperty(this, "_remainingWeeklyDeposits", void 0);
    _defineProperty(this, "_remainingWeeklyWithdrawals", void 0);
    _defineProperty(this, "configPromise", void 0);
    _initializerDefineProperty(this, "isTransferStarted", _descriptor17, this);
  }
  get remainingWeeklyDeposits() {
    if (this._remainingWeeklyDeposits !== undefined) {
      return this._remainingWeeklyDeposits;
    }
    if (this.requestedMoney && this.sfsCustomerApi.remainingWeeklyDeposits) {
      const amount = this.sfsCustomerApi.remainingWeeklyDeposits.amount - this.requestedMoney.amount;
      return Money.create({
        amount,
        currency: Currency.USD
      });
    } else {
      return null;
    }
  }
  set remainingWeeklyDeposits(value) {
    set(this, '_remainingWeeklyDeposits', value);
  }
  get remainingWeeklyWithdrawals() {
    if (this._remainingWeeklyWithdrawals !== undefined) {
      return this._remainingWeeklyWithdrawals;
    }
    if (this.requestedMoney && this.sfsCustomerApi.remainingWeeklyWithdrawals) {
      const amount = this.sfsCustomerApi.remainingWeeklyWithdrawals.amount - this.requestedMoney.amount;
      return Money.create({
        amount,
        currency: Currency.USD
      });
    } else {
      return null;
    }
  }
  set remainingWeeklyWithdrawals(value) {
    set(this, '_remainingWeeklyWithdrawals', value);
  }
  get isFolderToFolderTransfer() {
    if (!this.primaryAccount || !this.secondaryAccount) {
      return false;
    }
    return this.primaryAccount.type === AccountType.SAVINGS_ACCOUNT && this.secondaryAccount instanceof Account && this.secondaryAccount.type === AccountType.SAVINGS_ACCOUNT;
  }
  // This function can be used in route hooks to wait for the promise passed
  // to `beginTransfer` to resolve.
  // Warning: anyone who depends on this must ensure that `beginTransfer` is
  // called beforehand otherwise this will just do `await undefined` and
  // proceed without the config.
  async ready() {
    await this.configPromise;
  }

  // This function must be called before entering a transfer flow.
  //
  // It takes a promise resolving to an object containing all of the required
  // data for a transfer.
  async beginTransfer(configPromise) {
    this.isTransferStarted = true;
    this.configPromise = configPromise;
    const config = await this.configPromise;
    this.isDeposit = config.isDeposit;
    this.primaryAccount = config.primary;
    this.setAmount(Money.create({
      amount: 0,
      currency: Currency.USD
    }));
    this.idempotencyKey = uuid();
    this.secondaryAccount = config.secondary;
    this.secondaryOptions = config.secondaryOptions;
    this.customerLimits = config.customerLimits;
  }
  async createTransfer() {
    if (!this.primaryAccount?.id || !this.secondaryAccount) {
      throw new Error('cannot transfer funds when missing a primary account or destination account');
    }
    if (!this.idempotencyKey) {
      throw new Error('cannot transfer funds without idempotency key set');
    }
    if (!this.requestedMoney) {
      throw new Error('cannot transfer funds without a requested amount set');
    }
    const transfer = await this.bankingTransferApi.createTransfer({
      srcAccount: this.isDeposit ? this.secondaryAccount : this.primaryAccount,
      destAccount: this.isDeposit ? this.primaryAccount : this.secondaryAccount,
      amount: this.requestedMoney,
      idempotenceKey: this.idempotencyKey
    });
    this.transfer = transfer;
    return transfer;
  }

  // Returns a validation object for the current transfer values owned by this
  // service.
  /* eslint-disable complexity */
  validate() {
    let validation = new Validation();
    if (!this.requestedMoney) {
      throw new Error('no money object to validate');
    }
    if (!this.customerLimits || !this.customerLimits.odfiDepositAmountPerTransactionMax || !this.customerLimits.odfiWithdrawalAmountPerTransactionMax) {
      throw new Error('no customer limits to validate');
    }
    const odfiDepositAmountPerTransactionMax = this.customerLimits.odfiDepositAmountPerTransactionMax.amount;
    const odfiWithdrawalAmountPerTransactionMax = this.customerLimits.odfiWithdrawalAmountPerTransactionMax.amount;
    const debitAccount = this.isDeposit ? this.secondaryAccount : this.primaryAccount;
    if (this.requestedMoney.amount === 0) {
      validation = new Validation(this.intl.t('sfs.shared.transfers.createTransfer.error.zeroAmount', {
        amount: formatMoney(this.requestedMoney, this.formatter)
      }));
    } else if (!this.isFolderToFolderTransfer && !this.isDeposit && this.requestedMoney.amount > odfiWithdrawalAmountPerTransactionMax) {
      validation = new Validation(this.intl.t('sfs.shared.transfers.createTransfer.error.perTransferLimit', {
        amount: formatMoney(Money.create({
          amount: odfiWithdrawalAmountPerTransactionMax,
          currency: Currency.USD
        }), this.formatter)
      }));
    } else if (!this.isFolderToFolderTransfer && this.isDeposit && this.requestedMoney.amount > odfiDepositAmountPerTransactionMax) {
      validation = new Validation(this.intl.t('sfs.shared.transfers.createTransfer.error.perTransferLimit', {
        amount: formatMoney(Money.create({
          amount: odfiDepositAmountPerTransactionMax,
          currency: Currency.USD
        }), this.formatter)
      }));
    } else if (!this.isFolderToFolderTransfer && !this.isDeposit && this.customerLimits.odfiWithdrawalAmountLimit && this.sfsCustomerApi.remainingWeeklyWithdrawals && this.exceedsOdfiWithdrawalLimit) {
      validation = new Validation(this.intl.t('sfs.shared.transfers.createTransfer.error.weeklyWithdrawalLimit', {
        remaining: formatMoney(this.sfsCustomerApi.remainingWeeklyWithdrawals, this.formatter),
        max: formatMoney(this.customerLimits.odfiWithdrawalAmountLimit, this.formatter),
        htmlSafe: true
      }));
    } else if (!this.isFolderToFolderTransfer && this.isDeposit && this.sfsCustomerApi.remainingWeeklyDeposits && this.customerLimits.odfiDepositAmountLimit && this.exceedsOdfiDepositLimit) {
      validation = new Validation(this.intl.t('sfs.shared.transfers.createTransfer.error.weeklyDepositLimit', {
        remaining: formatMoney(this.sfsCustomerApi.remainingWeeklyDeposits, this.formatter),
        max: formatMoney(this.customerLimits.odfiDepositAmountLimit, this.formatter),
        htmlSafe: true
      }));
    } else if (debitAccount instanceof Account && debitAccount.availableBalance?.amount && this.requestedMoney.amount > debitAccount.availableBalance?.amount) {
      if (debitAccount.type === AccountType.SAVINGS_ACCOUNT) {
        validation = new Validation(this.intl.t('sfs.shared.transfers.createTransfer.error.insufficientFundsFolder'));
      } else {
        validation = new Validation(this.intl.t('sfs.shared.transfers.createTransfer.error.insufficientFundsAccount'));
      }
    } else if (this.isSecondaryAccountExternalAndVerifying) {
      validation = new Validation(this.intl.t('sfs.shared.transfers.createTransfer.error.linkedAccountVerifying'));
      validation.level = 'warn';
    } else if (this.isSecondaryAccountExternalAndBlocked) {
      validation = new Validation(this.intl.t('sfs.shared.transfers.createTransfer.error.secondaryAccountBlocked', {
        bankName: this.secondaryAccount.bankName
      }));
    }
    return validation;
  }
  /* eslint-enable complexity */

  get exceedsOdfiWithdrawalLimit() {
    if (!this.requestedMoney || !this.customerLimits || !this.sfsCustomerApi.remainingWeeklyWithdrawals) {
      return false;
    }
    return this.requestedMoney.amount > this.sfsCustomerApi.remainingWeeklyWithdrawals.amount;
  }
  get exceedsOdfiDepositLimit() {
    if (!this.requestedMoney || !this.customerLimits || !this.sfsCustomerApi.remainingWeeklyDeposits) {
      return false;
    }
    return this.requestedMoney.amount > this.sfsCustomerApi.remainingWeeklyDeposits.amount;
  }
  estimateTransferEvents() {
    if (this.secondaryAccount instanceof ExternalBankAccount && this.primaryAccount instanceof Account && this.primaryAccount.type === AccountType.SAVINGS_ACCOUNT) {
      const fromAccountId = this.isDeposit ? this.secondaryAccount.id : this.primaryAccount.metadata?.savingsAccount?.sfsAccountId;
      const toAccountId = this.isDeposit ? this.primaryAccount.metadata?.savingsAccount?.sfsAccountId : this.secondaryAccount.id;
      if (fromAccountId && toAccountId) {
        return this.sfsTransferApi.listEstimatedTransferEvents(fromAccountId, toAccountId, new Date(), TransferType.EXTERNAL_TRANSFER);
      }
    }
    return Promise.resolve([]);
  }
  setAmount(amount) {
    this.requestedMoney = amount;
  }
  clearTransfer() {
    this.isTransferStarted = false;
    this.secondaryAccount = null;
    this.primaryAccount = undefined;
    this.requestedMoney = undefined;
    this.transfer = undefined;
  }
  setSecondaryAccount(secondaryAccount) {
    this.secondaryAccount = secondaryAccount;
  }
  get isSecondaryAccountExternalAndVerifying() {
    if (this.secondaryAccount instanceof ExternalBankAccount) {
      return this.secondaryAccount.linkStatus === ExternalBankAccount.LinkStatus.VERIFYING;
    }
    return false;
  }
  get isSecondaryAccountExternalAndBlocked() {
    if (this.secondaryAccount instanceof ExternalBankAccount) {
      return this.sfsExternalBankAccountApi.isAccountLinkBroken(this.secondaryAccount);
    }
    return false;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "sfsCustomerApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "sfsTransferApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "bankingTransferApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "sfsExternalBankAccountApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "features", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "secondaryAccount", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "secondaryOptions", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "requestedMoney", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "primaryAccount", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "transfer", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "isDeposit", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "idempotencyKey", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "customerLimits", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "remainingWeeklyDeposits", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "remainingWeeklyDeposits"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "remainingWeeklyWithdrawals", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "remainingWeeklyWithdrawals"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isFolderToFolderTransfer", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "isFolderToFolderTransfer"), _class.prototype), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "isTransferStarted", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "exceedsOdfiWithdrawalLimit", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "exceedsOdfiWithdrawalLimit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "exceedsOdfiDepositLimit", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "exceedsOdfiDepositLimit"), _class.prototype), _class);
export { CurrentTransfer as default };